<template>
    <div class="m-top-nav-bar">
        <div v-if="!removeMenu" class="wrapper">
            <base-menu class="main-nav" :menu="nav" :normalize-label="true"></base-menu>
        </div>
        <div v-if="title" class="page-title-con">
            <i class="icon pos-left icon-left-arrow" @click="handleBackClick"></i>
            <div class="title-con" :class="{'xsmall': xsmallTitle}"><span>{{ title | translate | normalize }}</span> <i v-if="iconInTitle" :class="`icon ${iconInTitle}`" @click="$emit('icon-in-title-click-event')"></i></div>
            <i :class="`icon pos-right ${iconRight}`" @click="$emit('right-icon-click-event')"></i>
        </div>
    </div>
</template>

<script>
    import BaseMenu from '@views/common/BaseMenu'
    import {handleBackBtn} from '@/helpers'
    export default {
        name: 'm-top-nav-bar',
        data() {
            return {
                nav: [
                    { name: 'My Profile', route: 'user-home', icon_class: 'icon icon-profile'},
                    { name: 'Search', route: 'user-search-profiles', icon_class: 'icon icon-search' },
                    { name: 'Messages', route: 'user-messages', icon_class: 'icon icon-envelope-solid', badge: null },
                    { name: 'Credits', route: 'user-credits', icon_class: 'icon icon-stars' },
                ],
            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            iconRight: {
                type: String,
                default: 'null'
            },
            iconInTitle: {
                type: String,
                default: ''
            },
            removeMenu: {
                type: Boolean,
                default: false
            },
            backFallbackRoute: {
                type: Object,
                default: () => {
                    {}
                }
            },
        },
        computed: {
            xsmallTitle() {
               return ['boost-profile', 'complete-register', 'claim-daily-icebreakers'].includes(this.$route.name);
            },
            routeFrom() {
                return this.$store.getters['pub/routeFrom']
            },
            unreadMessages() {
                let i = this.$store.getters['auth/profile']['welcome_message'] == 1 ? 1 : 0
                let n = parseInt(this.$store.getters['auth/unreadNotifications'])
                return parseInt(this.$store.getters['auth/unreadMessages']) + i + n
            },
            gender() {
                return this.$store.getters['auth/profile']['sex']
            }
        },
        methods: {
            populateUnreadMessage(val) {
                this.nav[2].badge = !val ? null : val.toString()
            },
            handleBackClick() {
                handleBackBtn(this.$router, this.routeFrom, this.backFallbackRoute)
            }
        },
        mounted() {
            if(this.unreadMessages) this.populateUnreadMessage(this.unreadMessages)
        },
        watch: {
            unreadMessages(to,from) {
                this.populateUnreadMessage(to)
            }
        },
        components: {
            BaseMenu
        }
    }
</script>

<style lang="scss">
.m-top-nav-bar {
    display: flex;
    flex-direction: column;
    .wrapper {
        background: #fff;
        position: relative;
        z-index: 99;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 0 40px 0 #d3d4d8;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        .main-nav {
            display: flex;
            width: 100%;
            ul {
                list-style: none;
                display: flex;
                flex-wrap: nowrap;
                text-align: center;
                position: relative;
                width: 100%;
                li {
                    flex-basis: 25%;
                    display: flex;
                    padding: 0 10px;
                    a {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        padding: 10px 0;
                        text-transform: uppercase;
                        font-size: 16px;
                        border-bottom: 4px solid transparent;
                        .label {
                            line-height: 1.1;
                        }
                        .icon {
                            position: relative;
                            margin-bottom: 5px;
                            font-size: 25px;
                            line-height: 1.5;
                            .badge {
                                font-family: Montserrat,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
                                position: absolute;
                                background-color: #3dba19;
                                top: -6px;
                                left: 16px;
                                padding: 4px 0;
                                border-radius: 50px;
                                font-size: 16px;
                                text-align: center;
                                color: #fff;
                                height: 30px;
                                min-width: 30px;
                            }
                        }
                        &.active {
                            border-bottom-color: #3dba19;
                        }
                    }
                    @media(max-width: 575px) {
                        a {
                            padding: 6px 0;
                            font-size: 9px;
                            .icon {
                                font-size: 15px;
                                .badge {
                                    top: -5px;
                                    padding: 2px 6px;
                                    height: 20px;
                                    min-width: 20px;
                                    font-size: 11px;
                                    left: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .page-title-con {
        position: relative;
        background: #eeeff4;
        border-bottom: 1px solid #d3d4d8;
        box-shadow: none;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15px 10px;
        text-transform: uppercase;
        .title-con {
            flex-grow: 1;
            text-align: center;
            font-size: 28px;
            line-height: 1;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            @media(max-width: 575px) {
                font-size: 18px;
            }
            > i.icon {
                padding-left: 10px;
            }
        }
        .xsmall {
            font-size: 14px !important;
        }
        i.icon {
            padding: 0;
            cursor: pointer;
            font-size: 16px;
            min-width: 26px;
            .pos-left {
                padding-right: 10px;
            }
            .pos-right {
                padding-left: 10px;
            }
        }
    }
}
</style>
